export enum QuoteDetailsEntryStatus {
  IN_CLARIFICATION = "IV01",
  MVCR_IN_CLARIFICATION = "MVCR",
  REJECTED = "EV01",
  ACCEPTED = "EV02",
  RELEASED = "OV10",
  ACTIVE = "Q1",
  EXPIRED = "Q2",
  NEW = "Q3",
  EXPIRING_SOON = "Q5",
  READY_FOR_ORDER = "Q6",
  OPEN = "H2",
  ALL = "ALL",
}

export function getItemStatus(status: string): QuoteDetailsEntryStatus {
  switch (status) {
    case "EV01":
      return QuoteDetailsEntryStatus.REJECTED;
    case "EV02":
      return QuoteDetailsEntryStatus.ACCEPTED;
    case "MVCR":
      return QuoteDetailsEntryStatus.MVCR_IN_CLARIFICATION;
    case "IV01":
      return QuoteDetailsEntryStatus.IN_CLARIFICATION;
    case "OV10":
    case "OV20":
      return QuoteDetailsEntryStatus.RELEASED;
    case "Q1":
      return QuoteDetailsEntryStatus.ACTIVE;
    case "Q2":
      return QuoteDetailsEntryStatus.EXPIRED;
    case "Q3":
      return QuoteDetailsEntryStatus.NEW;
    case "Q5":
      return QuoteDetailsEntryStatus.EXPIRING_SOON;
    case "Q6":
      return QuoteDetailsEntryStatus.READY_FOR_ORDER;
    case "H2":
      return QuoteDetailsEntryStatus.OPEN;
    case "ALL":
    default:
      return QuoteDetailsEntryStatus.ALL;
  }
}
